import React from 'react';
import HeaderStyleInput from "./HeaderStyleInput";
import HeaderSizeInput from "./HeaderSizeInput";
import HeaderTitleInput from "./HeaderTitleInput";
import HeaderShortTitleInput from "./HeaderShortTitleInput";
import HeaderTitleURLInput from "./HeaderTitleURLInput";
import HeaderTitleOnClickInput from "./HeaderTitleOnClickInput";
import ModifierClassesInput from "./ModifierClassesInput";
import SearchInput from "./SearchInput/SearchInput";
import IconInputCommon from "./IconInput/IconInputCommon";
import HeaderLogoInput from "./HeaderLogoInput";
import {observer} from "mobx-react";
import ConfiguratorUtahId from "../UtahId/ConfiguratorUtahId";

const propTypes = {};
const defaultProps = {};

const ConfiguratorInputs = () => {

	return (
		<div className="configurator__inputs">
			<HeaderStyleInput/>
			<HeaderSizeInput/>
			<HeaderTitleInput/>
			<HeaderShortTitleInput/>
			<HeaderTitleURLInput/>
			<HeaderTitleOnClickInput/>
			<HeaderLogoInput/>
			<ModifierClassesInput/>
			<IconInputCommon iconName="appGrid" iconTitle="Grid"/>
			<SearchInput/>
			<IconInputCommon iconName="gear" iconTitle="Gear"/>
			<IconInputCommon iconName="question" iconTitle="Question"/>
			<ConfiguratorUtahId/>
		</div>
	);
};

ConfiguratorInputs.propTypes = propTypes;
ConfiguratorInputs.defaultProps = defaultProps;

export default observer(ConfiguratorInputs);
